import { EducationLevelGroup } from '../school/schoolLevel.enum';

export const EducationLevelGradeRange = {
    [EducationLevelGroup.PRESCHOOL]: 'PRESCHOOL_EDUCATION',
    [EducationLevelGroup.JUNIOR_SCHOOL]: 'GRADES_1_TO_4',
    [EducationLevelGroup.HIGH_SCHOOL]: 'GRADES_5_TO_11'
};
